<template>
  <NewgameWrapper ref="newGameWrapper" :location="4" :showBottomNav="true">
    <Scroll ref="scroll" :class="$style.box" :pulldown="true" @bsPullingDown="bsPullingDown">
      <div>
        <!-- 新游推荐顶部banner -->
        <NewgameWrapperTopbanner v-if="topBannerList.length > 0" :topBannerList="topBannerList" />
        <TopHeader headerTitle="个人主页" :isShowMenuIcon="false" />
        <!-- 个人主页用户信息部分 -->
        <div
          v-if="isRegister"
          :class="$style['user-info']"
          :style="{ backgroundImage: `url(${infoBar_bg})` }"
        >
          <img :class="$style.avatar" :src="forum_user.forum_image" @click="changeAvatar" />
          <div :class="$style['info_container']">
            <p>{{ forum_user.forum_name }}</p>
            <p>
              {{ !forum_user.motto ? '这个人很懒，什么都没有留下^-^' : forum_user.motto }}
            </p>
          </div>
          <router-link to="./modifyInfo">
            <div :class="$style.edit" @click="handleEdit">
              <img :src="editImage" alt="编辑" />
              <span>编辑</span>
            </div>
          </router-link>
        </div>
        <div v-else :class="$style['user-info']" :style="{ backgroundImage: `url(${infoBar_bg})` }">
          <img :class="$style.avatar" :src="photoImg" @click="handleRegister" />
          <div :class="$style['info_container']" @click="handleRegister">
            <p>点击注册</p>
          </div>
        </div>
        <div :class="$style.line"></div>
        <!-- 单元格数组 -->
        <van-cell
          v-for="(item, index) of cellConfig"
          :key="index"
          :class="$style.cells"
          :is-link="item.isLink"
          :value="item.value"
          :to="item.to"
          @click="clickCell(item.title)"
        >
          <template #title>
            <span class="custom-title">{{ item.title }}</span>
            <span v-if="redPointShow(item.title)" :class="$style['red-point']"></span>
          </template>
        </van-cell>
      </div>
    </Scroll>
  </NewgameWrapper>
</template>

<script>
import NewgameWrapper from '_c/NewgameWrapper';
import NewgameWrapperTopbanner from '_c/NewgameWrapperTopbanner';
import Scroll from '_c/Scroll';
import TopHeader from '_c/TopHeader';
import { Cell, Tag, Toast } from 'vant';
import UploadMixin from '@/mixins/uploadImage';
import { getUserUnreadNumber } from '@/api/personalCenter';
import { reportData } from '@/api/report';
import { setAvatar } from '@/api/account';
import { mapActions, mapState, mapMutations } from 'vuex';
import { CDN_URL } from '@/config/index.js';
import bindAccountMixin from '@/mixins/bindAccountMixin.js'
export default {
  components: {
    NewgameWrapper,
    NewgameWrapperTopbanner,
    Scroll,
    TopHeader,
    VanCell: Cell,
  },
  mixins: [UploadMixin, bindAccountMixin],
  data() {
    return {
      returnIcon: `${this.$cdnUrl}/back.png`, // 返回小图标
      infoBar_bg: `${CDN_URL}/personal_header_bg.png`, // 用户信息栏背景
      editImage: `${this.$cdnUrl}/edit.png`, // 编辑小图标
      photoImg: `${CDN_URL}/register/photo.png`, // 头像背景
      unreadNumber: '', // 未读消息数
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: (state) => state.userInfo,
    }),
    ...mapState('gameCircleCenter', {
      topBannerList: (state) => state.topBannerList,
    }),
    // 判断是否注册论坛
    isRegister() {
      let flag = this.userInfo.forum_user_id != 0 ? true : false;
      return flag;
    },
    // 论坛用户信息
    forum_user() {
      return this.userInfo.forum_user;
    },
    // 单元格配置
    cellConfig() {
      return [
        //   {
        //   title: '我的消息',
        //   isLink: true,
        //   to: 'myNews'
        // },
        {
          title: '我的礼包',
          isLink: true,
        },
        // {
        //   title: '绑定手机号',
        //   isLink: true,
        //   value: this.userInfo.forum_user.bind_phone ? '已绑定' : ''
        // },
        {
          title: '绑定游戏账号',
          isLink: true,
          value: this.userInfo.game_user_id ? '已绑定' : '',
        },
        {
          title: '我的代金券',
          isLink: true,
        },
      ];
    },
  },
  created() {
    this.getUserUnreadNumber();
  },
  mounted() {
    reportData({
      type: 4,
      data_type: 1,
    });
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_BIND_PHONE: 'CHANGE_BIND_PHONE',
      CHANGE_BIND_GAME: 'CHANGE_BIND_GAME',
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING',
      CHANGE_REGISTER_DIALOG: 'CHANGE_REGISTER_DIALOG',
    }),
    ...mapActions('account', {
      getUserInfo: 'getUserInfo',
    }),
    async setAvatar(src) {
      this.CHANGE_SHOW_LOADING(true);
      let r = {};
      try {
        r = await setAvatar({
          image: src,
        });
        this.getUserInfo();
        if (r.code == 0) {
          Toast.fail(r.message);
        } else {
          Toast.success('头像更换成功');
        }
      } catch (error) {
        Toast.fail(error.message);
      } finally {
        this.CHANGE_SHOW_LOADING(false);
      }
    },
    // 修改用户头像
    changeAvatar() {
      reportData({
        type: 4,
        data_type: 2,
      });
      this.uploadImage(1, false);
    },
    // 获取未读消息数
    async getUserUnreadNumber() {
      const r = await getUserUnreadNumber();
      this.unreadNumber = r.data.num;
    },
    // 是否显示未读消息红点点
    redPointShow(title) {
      switch (title) {
        case '我的消息':
          if (Number(this.unreadNumber) > 0) {
            return true;
          } else {
            return false;
          }
        default:
          return;
      }
    },
    // 点击单元格
    clickCell(title) {
      switch (title) {
        case '绑定手机号':
          reportData({
            type: 4,
            data_type: 4,
          });
          // if (!this.isRegister) {
          //   this.CHANGE_REGISTER_DIALOG(true);
          //   return
          // }
          this.CHANGE_BIND_PHONE(true);
          break;
        case '绑定游戏账号':
          reportData({
            type: 4,
            data_type: 5,
          });
          // if (!this.isRegister) {
          //   this.CHANGE_REGISTER_DIALOG(true);
          //   return
          // }
          this.CHANGE_BIND_GAME(true);
          break;
        case '我的礼包':
          reportData({
            type: 4,
            data_type: 6,
          });
          // if (!this.isRegister) {
          //   this.CHANGE_REGISTER_DIALOG(true);
          //   return
          // }
          this.$router.push({ name: 'personalCenter.myGift' });
          break;
        case '我的代金券':
          // if (!this.isRegister) {
          //   this.CHANGE_REGISTER_DIALOG(true);
          //   return
          // }
          this.$router.push({ name: 'activity.vouchers' });
          break;
        default:
          return;
      }
    },
    handleScroll(pos) {
      console.log(pos.y);
      if (pos.y > 80) {
        this.$refs.newGameWrapper.openNewGame();
      }
    },
    // 下拉加载
    bsPullingDown() {
      this.$refs.newGameWrapper.openNewGame();
      setTimeout(() => {
        this.$refs.scroll && this.$refs.scroll.refresh();
      }, 10);
    },
    // 点击编辑
    handleEdit() {
      reportData({
        type: 4,
        data_type: 3,
      });
    },
    // 点击注册
    handleRegister() {
      this.CHANGE_REGISTER_DIALOG(true);
    },
    onChangeAccount () {
      this.getUserUnreadNumber()
    },
  },
};
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.box {
  width: 100%;
  height: calc(100vh - 60px);
  > div {
    min-height: 100vh;
  }
}
.user-info {
  position: relative;
  width: 100%;
  height: 120px;
  background-repeat: no-repeat;
  background-size: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .avatar {
    margin-right: 10px;
    width: 64px;
    height: 64px;
    display: block;
    border: 2px solid white;
    border-radius: 50%;
  }
  .info_container {
    margin-top: 10px;
    width: 220px;
    color: white;
    > p:first-child {
      height: 20px;
      line-height: 20px;
      font-size: 15px;
    }
    > p:last-child {
      @include ellipsis(2);
      margin-top: 6px;
      height: 30px;
      font-size: 13px;
      line-height: 16px;
      word-break: break-word;
    }
  }
  .edit {
    position: absolute;
    top: 14px;
    right: 25px;
    > img {
      width: 16px;
    }
    > span {
      position: relative;
      top: -3px;
      left: 5px;
      font-size: 14px;
      color: #fff;
    }
  }
}
.line {
  width: 100%;
  height: 7px;
  background-color: #efefef;
}
.cells {
  .custom-title {
    margin-right: 4px;
    vertical-align: middle;
  }
  .red-point {
    width: 5px;
    height: 5px;
    display: inline-block;
    border-radius: 50%;
    background-color: #f52a2a;
    transform: translate3d(5px, -2px, 0px);
  }
}
</style>